// Angular
import { Injector, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ConnectionService } from 'ng-connection-service';
import { Observable } from 'rxjs';
// States
import { UserContextState } from '../auth/user-context.state';

export const SKIP_AUTH_HEADER = 'SKIP_AUTH_HEADER';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	private oidcSecurityService: OidcSecurityService;
	private isConnected: boolean;

	constructor(private injector: Injector, private store: Store, private connectionService: ConnectionService) {
		this.isConnected = true;
		this.connectionService.monitor().subscribe((isConnected) => {
			this.isConnected = isConnected;
		});
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return this.handleRequest(request, next);
	}

	/**
	 * Capture the current request and performs some validations
	 * @param request
	 * @param next
	 */
	private handleRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!request.headers.has(SKIP_AUTH_HEADER)) {
			if (!this.oidcSecurityService) {
				this.oidcSecurityService = this.injector.get(OidcSecurityService);
			}

			if (this.oidcSecurityService) {
				let token: any = this.oidcSecurityService.getAccessToken();

				if (!token) {
					token = this.store.selectSnapshot(UserContextState.token);
				}

				// if (!request.headers.has(SKIP_AUTH_HEADER) && token) { }
				if (token) {
					request = request.clone({
						setHeaders: {
							'Cache-Control': 'no-cache',
							Authorization: `Bearer ${token}`,
							'ngsw-bybass': 'true',
						},
					});
				}
			}
		}

		return next.handle(request);
	}
}
